export default __webpack_public_path__ + "static/media/Quotes.2774392f.svg";